import React, { useRef } from 'react'
import Autocomplete from "react-google-autocomplete";
import { GOOGLE_MAPS_APIKEY } from '../../store/Apis'
import styles from './autoCompleteAddress.module.css'

function AutoCompleteAddress({ onSelectLocation, clearFieldOnSelect, address, placeholder, label, setClearField, clearField }) {

    const locationRef = useRef()
    console.log('render================================');
    const selectLocation = (places) => {
        onSelectLocation(places)
        if (clearFieldOnSelect) {
            locationRef.current.value = ''
        }
    }

    if (clearField) {
        locationRef.current.value = ''
        setClearField(false)
    }

    return (
        <div className={styles.main_input}>
            <text className={styles.label}>{label}</text>
            <div
                className={styles.input}
                style={{
                    display: "flex",
                }}
            >
                <Autocomplete
                    apiKey={GOOGLE_MAPS_APIKEY}
                    ref={locationRef}
                    defaultValue={address}
                    style={{ width: "100%" }}
                    className={styles.addressClass}
                    placeholder={placeholder ? placeholder : "Enter Address"}
                    onPlaceSelected={selectLocation}
                    options={{
                        types: ["geocode", "establishment"],
                    }}
                    language={'en'}
                />
                {/* {rightIcon ? (
                    <FaCalendarAlt className={styles.icon} />
                ) : null} */}
            </div>
        </div>
    )
}

export default AutoCompleteAddress